<template>
    <div>
        <LoadingOverlay :loading="loading" class="popupLoading" />
        <div class="fixHeight cargame-rank-listWrap" ref="tableContainer">
            <div class="listBoxes" v-for="(reward, index) in CarRankLastWeekData" :key="index">
                <div class="leftBxb">
                    <div class="text-white s-no" v-if="index > 2">{{ index + 1 }}</div>
                    <div class="s-no" v-else-if="index === 0">
                        <img :src='rankNoIcon1' class="rankNumbImage" alt="Rank Icon" />
                    </div>
                    <div class="s-no" v-else-if="index === 1">
                        <img :src='rankNoIcon2' class="rankNumbImage" alt="Rank Icon" />
                    </div>
                    <div class="s-no" v-else-if="index === 2">
                        <img :src='rankNoIcon3' class="rankNumbImage" alt="Rank Icon" />
                    </div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='(reward.image.length > 0) ? reward.image : defaultUserImage' alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="text-white userName">{{ reward.name }}</div>
                        <div class="lavel-box">
                            <img :src="getLevelImage(reward.rich_level)" class="lavelImage" alt="level icon" />
                            <span class="lavel-value">{{ reward.rich_level }}</span>
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <img :src='profitCountIcon' class="diamondIcon" alt="beans icons" />{{ reward.profit_count }}
                    </div>
                    <div class="carrace_reward_val reward_text" v-if="reward.reward_coin > 0">Reward : {{ reward.reward_coin }}</div>
                </div>
            </div>
            <div v-if="scrollLoading" class="text-white border-0 mb-2 scrollLoading">Loading...</div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import LoadingOverlay from '../LoadingOverlay.vue'
import profitCountIcon from '../../assets/images/profit_count.webp'
import defaultUserImage from '../../assets/images/default_profile.webp';
import yellowLabelIconBGImage from '../../assets/images/yellow-label-bg.webp';
import rankNoIcon1 from '../../assets/images/rankno-icon-1.webp';
import rankNoIcon2 from '../../assets/images/rankno-icon-2.webp'
import rankNoIcon3 from '../../assets/images/rankno-icon-3.webp'

import lvl0 from '@/assets/images/rich-lavel-0.png';
import lvl1 from '@/assets/images/rich-lavel-1.png';
import lvl2 from '@/assets/images/rich-lavel-2.png';
import lvl3 from '@/assets/images/rich-lavel-3.png';
import lvl4 from '@/assets/images/rich-lavel-4.png';
import lvl5_8 from '@/assets/images/rich-lavel-5-8.png';
import lvl9_11 from '@/assets/images/rich-lavel-9-11.png';
import lvl12 from '@/assets/images/rich-lavel-12.png';
import lvl13 from '@/assets/images/rich-lavel-13.png';
import lvl14 from '@/assets/images/rich-lavel-14.png';
import lvl15 from '@/assets/images/rich-lavel-15.png';
export default {
    name: 'RankLastweekComponent',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            CarRankLastWeekData: [],
            currentPage: 1,
            totalPages: 1,
            loading: false,
            scrollLoading: false,
            profitCountIcon,
            defaultUserImage,
            yellowLabelIconBGImage,
            rankNoIcon1,
            rankNoIcon2,
            rankNoIcon3,
            lvl0,
            lvl1,
            lvl2,
            lvl3,
            lvl4,
            lvl5_8,
            lvl9_11,
            lvl12,
            lvl13,
            lvl14,
            lvl15,
        }
    },
    mounted() {
        this.fetchCarRankLastWeekData();
        this.setupScrollListener();
    },
    methods: {
        fetchCarRankLastWeekData() {
            if (this.loading || this.scrollLoading) return;
            this.scrollLoading = this.currentPage > 1;
            this.loading = this.currentPage === 1;
            const apiUrl = `api/cargame/rank_weakly_api.php?page=${this.currentPage}&type=2`;
            axios.get(apiUrl)
                .then(response => {
                    this.CarRankLastWeekData = [...this.CarRankLastWeekData, ...response.data.data];
                    this.totalPages = response.data.total_pages;
                    this.checkAllImagesExist();
                })
                .catch(error => {
                    console.error("Error Featching Car Rank Data", error)
                })
                .finally(() => {
                    this.loading = false;
                    this.scrollLoading = false;
                })
        },
        // getLevelImage(rich_level) {
        //     const lvl = Number(rich_level) || 0;

        //     if (lvl >= 5 && lvl <= 8) return lvl5_8;
        //     if (lvl >= 9 && lvl <= 11) return lvl9_11;

        //     const map = {
        //         0: lvl0,
        //         1: lvl1,
        //         2: lvl2,
        //         3: lvl3,
        //         4: lvl4,
        //         12: lvl12,
        //         13: lvl13,
        //         14: lvl14,
        //         15: lvl15,
        //     };

        //     return map[lvl] ?? lvl0;
        // },
        getLevelImage(rich_level) {
            const rich_lavel = Number(rich_level) || 0;
            switch (true) {
                case rich_lavel === 0:
                return this.lvl0;

                case rich_lavel === 1:
                return this.lvl1;

                case rich_lavel >= 2 && rich_lavel <= 10:
                return this.lvl2; // same image for level 2-10

                case rich_lavel >= 11 && rich_lavel <= 20:
                return this.lvl3; // same image for level 11-20

                case rich_lavel >= 21 && rich_lavel <= 30:
                return this.lvl5_8; // same image for level 21-30

                case rich_lavel >= 31 && rich_lavel <= 40:
                return this.lvl12; // same image for level 31-40

                case rich_lavel >= 41 && rich_lavel <= 50:
                return this.lvl15; // same image for level 41-50

                default:
                return this.lvl0;
            }
        },
        checkAllImagesExist() {
            this.CarRankLastWeekData.forEach(reward => {
                if (reward.image.length > 0) {
                    const imageUrl = reward.image;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.image = this.defaultUserImage;
                            }
                        });
                }
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },
        setupScrollListener() {
            const container = this.$refs.tableContainer;
            if (container) {
                container.addEventListener('scroll', this.handleScroll);
            }
        },
        handleScroll() {
            const container = this.$refs.tableContainer;
            if (!container) return;

            const scrollPosition = container.scrollTop + container.clientHeight;
            const pageHeight = container.scrollHeight;

            if ((this.loading || this.scrollLoading) == false && scrollPosition >= pageHeight - 100 && this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchCarRankLastWeekData();
            }
        }
    },
}
</script>